import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Checkbox, Tooltip } from 'hljd'
import { getObjValue } from '@hlj/hlj-utils'
import styles from '../style.module.less'
import mStore from '../../store'
import { getStatus, formatPrice, getTotalPrice } from '../../../func'

@observer
export default class extends Component {
  render() {
    const {
      details: {
        actual_money,
        bd_name,
        channel,
        created_at,
        is_multi_pay,
        trade_no,
        status,
        order_subs = [],
        paid_money,
        id,
        pay_time,
        coupon
      },
      protocol_checked
    } = mStore
    let is_multiPay = status == '0' && is_multi_pay == '1'
    let is_shouldPay = status == '0' && (!is_multi_pay || is_multi_pay == '0')
    let shouldPay = (
      parseFloat(actual_money) - parseFloat(paid_money || 0)
    ).toFixed(2)
    let protocols = order_subs.map(product => {
      let title = getObjValue(product, 'protocol_title')
      let content = getObjValue(product, 'protocol_content')
      return (
        <span
          key={product.id}
          style={{ cursor: 'pointer', color: '#448afc' }}
          onClick={mStore.showProtocolModal(title, content)}
        >
          {title && '《' + title + '》'}
        </span>
      )
    })
    const { coupon_name, coupon_type, money_value, money_sill, gift_day } =
      coupon || {}
    let discountTxt = ''
    if (coupon_type == 3) {
      discountTxt = <span>{`${coupon_name}：赠送${gift_day || 0}天`}</span>
    } else {
      discountTxt = (
        <span>{`${coupon_name}：${
          coupon_type == 1 ? `满${money_sill || 0}` : ''
        }减${money_value || 0}`}</span>
      )
    }
    return (
      <div className={styles.general}>
        <p>订单概况</p>
        <ul>
          <li>
            订单状态：<span style={getStatus(status).style}>
              {getStatus(status).status}
            </span>
          </li>
          <li className={styles.flex}>
            <p>
              <span>订单号：</span>
              {trade_no}
            </p>
            <p>
              <span>渠道：</span>
              {channel == '1'
                ? '线上下单'
                : `线下创建（客户经理：${bd_name || ''}）`}
            </p>
          </li>
          <li className={styles.flex}>
            <p>
              <span>创建时间：</span>
              {created_at}
            </p>
            <p>
              <span>支付时间：</span>
              {pay_time || '-'}
            </p>
          </li>
          <li className={styles.flex}>
            <p>
              <span>原价：</span>
              <span>
                {formatPrice(getTotalPrice(order_subs, 'original_money'))}
              </span>
              {coupon_type && (
                <span className={styles.discount}>
                  （活动优惠<Tooltip placement="bottom" title={discountTxt}>
                    <QuestionCircleOutlined style={{ marginLeft: 2 }} />
                  </Tooltip>：{coupon_type == 3
                    ? `+${gift_day}天`
                    : `-${formatPrice(money_value)}`}）
                </span>
              )}
              {channel != '1' &&
                bd_name &&
                getTotalPrice(order_subs, 'original_money') - actual_money >
                  0 && (
                  <span className={styles.discount}>
                    （活动优惠<Tooltip
                      placement="bottom"
                      title={`线下活动：减${getTotalPrice(
                        order_subs,
                        'original_money'
                      ) - actual_money}`}
                    >
                      <InfoCircleOutlined style={{ marginLeft: 2 }} />
                    </Tooltip>：-{formatPrice(
                      getTotalPrice(order_subs, 'original_money') - actual_money
                    )}）
                  </span>
                )}
            </p>
            <p>
              <span>订单金额：</span>
              <span className={styles.price}>{formatPrice(actual_money)}</span>
              {is_shouldPay && (
                <Button
                  type="primary"
                  style={{ marginLeft: 20 }}
                  disabled={!protocol_checked}
                  onClick={mStore.goPay(shouldPay, id, trade_no)}
                >
                  立即支付
                </Button>
              )}
            </p>
          </li>
          {is_multiPay && (
            <li className={styles.flex}>
              <p>
                <span>已付金额：</span>
                <span>{formatPrice(paid_money)}</span>
              </p>
              <p>
                <span>还需支付：</span>
                <span className={styles.price}>{formatPrice(shouldPay)}</span>
                <Button
                  type="primary"
                  style={{ marginLeft: 20 }}
                  disabled={!protocol_checked}
                  onClick={mStore.goPay(shouldPay, id, trade_no)}
                >
                  立即支付
                </Button>
              </p>
            </li>
          )}
          {status == '1' && (
            <li className={styles.flex}>
              <p>
                <span>实付金额：</span>
                <span>{formatPrice(paid_money)}</span>
              </p>
            </li>
          )}
          {status != '1' &&
            !is_multiPay && (
              <li>
                <Checkbox
                  style={{ verticalAlign: '2px', marginRight: 12 }}
                  checked={protocol_checked}
                  onChange={mStore.checkChange}
                  disabled={status == '1'}
                />我已阅读并同意
                {protocols}
              </li>
            )}
        </ul>
      </div>
    )
  }
}
